import { Table } from "antd";
import { Edit, Trash2 } from "lucide-react";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { handleFetchSites } from "../../../apis/sites";
import Something from "../../../components/Something";
import BackLink from "../../../components/BackLink";
import CreateSite from "./components/CreateSite";
import UpdateSite from "./components/UpdateSite";
import DeleteSite from "./components/DeleteSite";

export default function Sites() {
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});

  const {
    data: sites,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["sites"],
    queryFn: handleFetchSites,
  });

  const columns = [
    {
      title: "S/N",
      width: 30,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "TYPE",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">{record?.siteType}</span>
      ),
    },
    {
      title: "COUNTY",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">{record?.county}</span>
      ),
    },
    {
      title: "WORKSHOP NAME",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">{record?.name}</span>
      ),
    },
    {
      title: "CONTACT",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">{record?.mobile}</span>
      ),
    },
    {
      title: "ADDRESS",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">{record?.address}</span>
      ),
    },
    {
      title: "ACTION",
      width: 70,
      render: (record: any) => (
        <div className="flex items-center">
          <div className="flex m-2">
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setUpdateModal(true);
              }}
              className="flex justify-center items-center mx-1 text-gray-700 border rounded-md px-2 py-1 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
            >
              <Edit size={16} />
            </button>
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setDeleteModal(true);
              }}
              className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-red-100 hover:bg-red-200 cursor-pointer"
            >
              <Trash2 size={16} />
            </button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-gray-100">
      <BackLink />
      <div className="bg-white p-2">
        <div className="flex justify-between border-b pb-2 pt-1 mb-2">
          <div className="flex flex-col">
            <div className="font-bold">Service Workshops</div>
            <div className="text-gray-500 text-xs">Manage Service Workshops</div>
          </div>
          <div className="">
            <button
              onClick={() => setCreateModal(true)}
              className="flex mx-2 justify-center items-center border px-4 py-1  hover:bg-gray-100"
            >
              + New
            </button>
          </div>
        </div>

        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="flex flex-col">
            <div className="flex flex-col w-full ">
              <div className="grid gap-x-0 grid-cols-12 border border-gray-200 rounded-md shadow-sm">
                <div className="col-span-12 sm:col-span-12 md:col-span-12">
                  <Table
                    columns={columns}
                    dataSource={sites?.records}
                    size="small"
                    bordered
                    pagination={{ pageSize: 20 }}
                    scroll={{ y: 525 }}
                    loading={isLoading}
                    rowKey="id"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <CreateSite
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={refetch}
      />

      <UpdateSite
        isVisible={updateModal}
        setVisible={setUpdateModal}
        selected={selected}
      />

      <DeleteSite
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={selected}
      />
    </div>
  );
}
